import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  ComboboxField,
  type ComboboxFieldOption,
} from 'components/DesignSystems/ComboboxField/ComboboxField';

type AddEventAssetsDialogProps = {
  open: boolean;
  options: ComboboxFieldOption[];
  isPending: boolean;
  onClose: () => void;
  onAdd: (resourceSetIds: UUID[]) => Promise<void>;
};

export const AddEventAssetsDialog: React.FC<AddEventAssetsDialogProps> = ({
  open,
  options,
  isPending,
  onClose,
  onAdd,
}) => {
  const [selected, setSelected] = useState<UUID[]>([]);

  const handleClose = () => {
    setSelected([]);
    onClose();
  };

  const handleAdd = async () => {
    await onAdd(selected);
    setSelected([]);
  };

  return (
    <Dialog open={open} onOpenChange={(next) => !next && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add assets at risk</DialogTitle>
        </DialogHeader>
        <ComboboxField
          label="Resource sets"
          multiple
          options={options}
          value={selected}
          onChange={(value) => setSelected((value as UUID[] | null) ?? [])}
          placeholder="Select resource sets"
          emptyMessage="No resource sets available."
        />
        <DialogFooter>
          <DialogClose render={<Button variant="outline" />}>
            Cancel
          </DialogClose>
          <Button
            disabled={selected.length === 0 || isPending}
            onClick={() => void handleAdd()}
          >
            Add
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
